module.exports = __webpack_public_path__ + "static/media/prev_arrow_dark.1d1622ef.svg";